import axios from 'axios';
import Swal from 'sweetalert2';
import { fetchAllPositionSkills } from './fetchAllPositionSkills';

export function deleteSkill(positionId, skillId) {
  return (dispatch) => {
    return axios
      .delete(`/position/skill/${skillId}`)
      .then((response) => {
        const { status } = response.data;
        if (status === 'SUCCESS') {
          Swal.fire({
            title: 'Success',
            text: 'Successfully deleted a skill',
            icon: 'success',
            confirmButtonColor: '#3f51b5',
          });
          dispatch(fetchAllPositionSkills(positionId));
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
}
